/**
 * @deprecated
 */
export const RENT_FREQUENCY = {
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
};
